<template>
  <div class="modal-wrapper">
    <h2 class="modal-title">{{ t("message.templateTitle") }}</h2>
    <div class="close" @click="$emit('close')">X</div>
    <div class="modal-body">
      <div class="row">
        <div class="col-6">
          <a :href="`${publicPath}templates\\LCN_Mustervorlage_EFH.zip`">
            <img
              :src="`${publicPath}images\\template\\gt8.png`"
              class="m-2"
              alt=""
              height="100"
            />
            <img
              :src="`${publicPath}images\\template\\gt12.png`"
              class="m-2"
              alt=""
              height="100"
            />
            <div class="row justify-content-center">
              <div>{{ t("message.modelProject") }}</div>
            </div></a
          >
        </div>
        <div class="col-6">
          <a
            :href="`${publicPath}templates\\LCN_Mustervorlage_EFH_weisse_Tasten.zip`"
          >
            <img
              :src="`${publicPath}images\\template\\gt8_w.png`"
              class="m-2"
              alt=""
              height="100"
            />
            <img
              :src="`${publicPath}images\\template\\gt12_w.png`"
              class="m-2"
              alt=""
              height="100"
            />
            <div class="row justify-content-center">
              <p>{{ t("message.modelProjectWhite") }}</p>
            </div></a
          >
        </div>
      </div>
    </div>
    <div class="row">
      <p class="small">{{ t("message.importDownload") }}</p>
    </div>
  </div>
</template>

<script>
import { useI18n } from "vue-i18n";
export default {
  setup() {
    const { t } = useI18n();
    const publicPath = process.env.BASE_URL;

    return { t, publicPath };
  },
};
</script>

<style lang="scss" scoped>
.modal-wrapper {
  background: white;
  width: 40%;
  margin: auto;
  padding: 1.5% 5% 0.5%;
  position: absolute;
  top: 130px;
  left: 45%;
  border: 1px solid #eee;
  border-top: none;
}
.modal-title {
  border-bottom: 1px solid #eee;
  padding-bottom: 2%;
}
@media (min-resolution: 108dpi) {
  .modal-wrapper {
    top: 17.2% !important;
    left: 49%;
  }
}
.close {
  position: absolute;
  right: 25px;
  top: 10px;
  width: 10px;
  cursor: pointer;
}
// @media (max-resolution: 96dpi) and (width: 1440px) {
//   .modal-wrapper {
//     top: 9.7% !important;
//     left: 41% !important;
//   }
// }
</style>
